import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { SearchSettingsResponse } from '@offconon/core-api';

import * as SearchSettingsActions from './search-settings.actions';
import { MenuSettings, SearchSettingsEntity } from './search-settings.models';

export const SEARCH_SETTINGS_FEATURE_KEY = 'search_settings';

export interface SearchSettingsState {
  searchSettings: Partial<SearchSettingsResponse> | undefined;
  menuSettings?: MenuSettings[];
  loaded: boolean;
}

export const searchSettingsAdapter: EntityAdapter<SearchSettingsEntity> =
  createEntityAdapter<SearchSettingsEntity>();

export const initialSearchSettingsState: SearchSettingsState =
  searchSettingsAdapter.getInitialState({
    searchSettings: undefined,
    loaded: true,
  });

const reducer = createReducer(
  initialSearchSettingsState,

  on(SearchSettingsActions.setUserSearchSettings, (state, { searchSettings }) => ({
    ...state,
    searchSettings,
  })),
  on(SearchSettingsActions.fetchMenuSettingListSuccess, (state, { menuSettings }) => ({
    ...state,
    menuSettings,
  })),
  on(SearchSettingsActions.editMenuSettingSuccess, (state, { menuSetting }) => ({
    ...state,
    menuSettings: state.menuSettings?.map((item) =>
      item.community_application_type === menuSetting.community_application_type
        ? {
            id: item.id,
            community_application_type: item.community_application_type,
            is_enabled: menuSetting.is_enabled,
          }
        : item,
    ),
  })),

  on(SearchSettingsActions.setLoaded, (state, { loaded }) => ({
    ...state,
    loaded,
  })),
);

export function searchSettingsReducer(
  state: SearchSettingsState | undefined,
  action: Action,
): SearchSettingsState {
  return reducer(state, action);
}
